<template>
  <div class="step">
    <div class="first">
      <div class="item">
        <div class="item-1">
          <div class="line-right"></div>
          <img src="../../../../assets/icon/panel/userred.png" alt="">
          <span>اطلاعات فردی</span>
        </div>
        <div class="item-2">


      <div class="" v-if="state.userInfo.authorized || state.userInfo.authenticationType =='CONFIRMED_IDENTITY'">
            <img src="../../../../assets/icon/panel/tick.png" width="10" alt="">
          <span>تایید شده</span>
      </div>


      <div class="" v-else >
            <img src="../../../../assets/icon/panel/cancel.png" alt="">
          <span>تایید نشده</span>
      </div>






          <img class="line" src="../../../../assets/icon/panel/bottom-red-line.png" alt="">
        </div>
      </div>


      <div class="item">
        <div class="item-1">
          <div class="line-right"></div>
          <img src="../../../../assets/icon/panel/walletgreen.png" alt="">
          <span>اطلاعات بانکی</span>
        </div>
        <div class="item-2">
      <div class="" v-if="!state.userInfo.authorized">
            <img src="../../../../assets/icon/panel/cancel.png" alt="">
          <span>تایید نشده</span>
      </div>

      <div class="" v-if="state.userInfo.authorized">
            <img src="../../../../assets/icon/panel/tick.png" alt="" width="10">
          <span>تایید شده</span>
      </div>






          <img class="line2" src="../../../../assets/icon/panel/green-line.png" alt="">
        </div>
      </div>


      <div class="item">
        <div class="item-1">
          <img src="../../../../assets/icon/panel/uploadred.png" alt="" >
          <span>آپلود مدارک</span>
        </div>
        <div class="item-2">
   <div class="" v-if="state.userInfo.authorized || state.userInfo.authenticationType =='CONFIRMED_IDENTITY'">
            <img src="../../../../assets/icon/panel/tick.png" width="10" alt="">
          <span>تایید شده</span>
      </div>


      <div class="" v-else >
            <img src="../../../../assets/icon/panel/cancel.png" alt="">
          <span>تایید نشده</span>
      </div>






          <img class="line3" src="../../../../assets/icon/panel/top-red-line.png" alt="">
        </div>
      </div>
    </div>
    <div class="second">
      <button @click="$router.push('/thekyc')" class="blue-btn">ویرایش اطلاعات</button>
    </div>

  </div>
</template>

<script>
export default {
  name: "step-auth"
}
</script>

<style lang="scss" scoped>
.line-right{
  height: calc(101% - 11px);
  width: 10px;
  border-right: 1px solid #D7C8C8;
  border-top: 1px solid #D7C8C8;
  border-bottom: 1px solid #D7C8C8;
  position: absolute;
  top: 30px;
  right: -3px;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
}
.step {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;

  .first {
    display: flex;
    flex-direction: column;
    width: 75%;

    .item{
      display: flex;
      flex-direction: row;
      color: #FBFBFD;
      width: 100%;
      gap: 50px;

      .item-1{
        width: 120px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: clamp(10px , 2vw , 14px);
        color: #FBFBFD;
        position: relative;

        span{
          display: ruby;
          white-space: nowrap;
        }
      }

      .item-2{
        display: flex;
        align-items: center;
        position: relative;
        font-size: clamp(8px , 2vw , 12px);
        color: #D7C8C8;

        .line{
          position: relative;
          top: 50%;
        }

        .line3{
          position: relative;
          bottom: 50%;
        }

        span{
          margin: 0 10px;
          display: ruby;
        }

      }
    }
  }

  .second{
    display: flex;
    align-items: center;
    justify-content: center;

    button{
      width: 100px;
      height: 32px;
    }
  }
}

@media (max-width: 768px) {
  .line{
    display: none;
  }

  .line3{
    display: none;
  }

  .line2{
    display: none;
  }
}
</style>